<template>
  <div class="main-container info-page">
    <div class="container">
      <h1 class="title">
        <span v-if="lang === 'it'">La storia attraverso <span><br>i reperti</span></span>
        <span v-if="lang === 'en'">History through <span><br>the artefacts</span></span>
        <span v-if="lang === 'de'">Geschichte durch <span><br>die Funde</span></span>
      </h1>

      <figure style="display: none;" class="immagine" v-for="(img, index) in this.pageData.field_page_immagini" :key="'spallaimg' + index">
      </figure>


      <div class="container intro-description " v-if="this.testiPagina[0]">
        <p v-html="this.testiPagina[0].attributes.field_text_with_summary.value">
        </p>
      </div>

    </div>
    <a class="go-back-btn" @click="goBack">
      <img src="@/assets/icon-arrow-o.svg" alt="">
      <div>
        <span v-if="lang === 'it'">Torna indietro</span>
        <span v-if="lang === 'en'">Go back</span>
        <span v-if="lang === 'de'">Zurück</span>
      </div>
    </a>
  </div>
</template>
<script>

import {
  fetchSinglePage,
  getTranslation
} from '../libs/drupalClient'

export default {
  name: 'la-storia-attraverso-i-reperti',
  components: {
  },
  data() {
    return {
      pageData: {
        attributes: {
          title: "La storia attraverso i reperti"
        }
      },
      currentPageID: "c111f013-0c30-4372-b82a-df5445f1f435"
    }
  },
  metaInfo() {
    return {
      title: this.objecttitle,
      meta: [{
        property: 'og:title',
        content: this.objecttitle
      }]
    }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/') // fallback
      }
    }
  },
  computed: {
    testiPagina() {
        //pageData has no texts until the page is fetched: the first render must not throw
        let a = (this.pageData.field_ref_ui_text || []).filter((f)=>{
          if ( f!=undefined && f.attributes.field_tipo == 'Testo pagina' ){
            return f
          }
        })
        return a
      },
    objecttitle() {
      var t = this.lang === 'it' ? "La storia attraverso i reperti" :
        this.lang === 'en' ? "History through the artefacts" :
          this.lang === 'de' ? "Geschichte durch die Funde"
            : "La storia";

      return t
    },
    imgUrl() {
      //pageData has no images until the page is fetched: until then there is no address
      if (this.pageData.field_page_immagini && this.pageData.field_page_immagini[0])
        return process.env.VUE_APP_ENDPOINT + this.pageData.field_page_immagini[0].attributes.uri.url
      else return ''
    },
    lang() {
      return this.$store.state.currentLang
    }
  },
  mounted() {
    fetchSinglePage(this.currentPageID, this.lang)
      .then(res => {
        this.pageData = res

        console.log('this.pageData', this.pageData);
      })
  },
  watch: {
    lang() {
      getTranslation(this.$route.name, this.lang)
        .then(res => {
          this.$router.push({
            path: res
          })
        })

      fetchSinglePage(this.currentPageID, this.lang)
        .then(res => this.pageData = res)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.intro-description {
  margin-bottom: 5rem;
  padding-left: 0;
  padding-right: 0;
}
.intro-description ::v-deep p {
  color: #fff;
}

.immagine {
  margin: 0;
  position: relative;
  width: 100%;
  height: auto;

  img {
    position: relative;
    width: 100%;
  }
}

.small {
  padding-bottom: 4rem;
}

.small ::v-deep p {
  color: #fff;
}

.info-page {
  background-color: #181923;
}

.title {
  padding-top: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding-bottom: 1rem;

  span {
    text-transform: uppercase;
    text-align: center;
    font-size: 30px;
    color: #fff;

    span {
      color: #C79641;
    }
  }
}
</style>